module.exports = __webpack_public_path__ + "assets/keypad-sounds/beep3-9cce1a61d8d36f7424be02658a0e7dd5.wav";